import axios from "axios";
import { getGPSInfo } from "./info";

interface Address {
  administrative_area_level_1?: string;
  administrative_area_level_2?: string;
  political?: string;
  country: string;
  formattedAddress: string;
  locality?: string;
  postal_code: string;
  route: string;
  street_number: string;
}

export interface FullAddress {
  latitude: number;
  longitude: number;
  address: string;
  country: string;
  postcode: string;
  province?: string;
  area?: string;
  aumpur?: string;
  tumbon?: string;
  road: string;
}

export const generateFullAddress = (
  address: Address,
  { latitude, longitude }: Coordinates
): FullAddress => {
  return {
    latitude,
    longitude,
    address: address.formattedAddress,
    country: address.country,
    postcode: address.postal_code,
    province: address.administrative_area_level_1,
    area: address.political,
    aumpur: address.administrative_area_level_2,
    tumbon: address.locality,
    road: address.route
  };
};

export const getAddress = async ({
  latitude,
  longitude
}: Coordinates): Promise<Address> => {
  const apiKey = process.env.VUE_APP_GOOGLE_MAPS_API;
  const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}&language=th`;
  const {
    data: {
      results: [
        {
          formatted_address: formattedAddress,
          address_components: addressComponents
        }
      ]
    }
  } = await axios.get(url);

  const address = addressComponents.reduce(
    (
      addressObject: Record<string, any>,
      currentAddress: Record<string, any>
    ) => {
      addressObject[currentAddress.types[0]] = currentAddress["long_name"];
      return addressObject;
    },
    {}
  );
  return { formattedAddress, ...address };
};

export const getFullAddress = async () => {
  let fullAddress: FullAddress | null = null;
  try {
    const { coords } = await getGPSInfo();
    const googleAddress = await getAddress(coords);
    fullAddress = generateFullAddress(googleAddress, coords);
  } catch (e) {
    /* do nothing */
  }
  return fullAddress;
};
